import loadable from "@loadable/component"
import { RouteObject } from "react-router-dom"

import { APP_ROUTES } from "~/shared/constants/routes"

const MobileConfigPage = loadable(
  async () => import("~/features/mobile-config/pages/MobileConfigPage"),
  { fallback: <></> },
)

export const mobileConfigRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.mobileConfig,
    element: <MobileConfigPage />,
  },
]
